var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 84,
    viewBox: "0 0 75 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 27,
    transform: "matrix(-1 0 0 1 75 57)",
    fill: "#496DFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 14,
    transform: "matrix(-1 0 0 1 47 70)",
    fill: "#496DFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 7,
    transform: "matrix(-1 0 0 1 66 77)",
    fill: "#496DFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 36,
    width: 8,
    height: 48,
    fill: "#496DFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 25,
    transform: "matrix(-1 0 0 1 38 59)",
    fill: "#496DFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 46,
    transform: "matrix(-1 0 0 1 56 38)",
    fill: "#496DFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 50,
    width: 10,
    height: 34,
    fill: "#496DFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    width: 8,
    height: 84,
    fill: "#496DFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.0d2f21efdf743f7042d63e6856e5088d.svg";
export { ForwardRef as ReactComponent };